import { handleActions } from "redux-actions";

import { COLLECTIONS } from "constants/action-types";

const initialState = {};

export default handleActions(
    {
        [COLLECTIONS.COLLECTION.BUDGET.CREATE.COMPLETED]: (state, { payload: { budget } }: any): IBudgetState => ({
            ...state,
            [budget.id]: budget,
        }),

        [COLLECTIONS.COLLECTION.BUDGET.FETCH.COMPLETED]: (state, { payload: { budgets } }: any): IBudgetState => ({
            ...state,
            ...budgets.reduce((target, budget) => Object.assign(target, { [budget.id]: budget }), {}),
        }),

        [COLLECTIONS.COLLECTION.BUDGET.UPDATE.COMPLETED]: (state, { payload: { budget } }: any): IBudgetState => ({
            ...state,
            [budget.id]: budget,
        }),

        [COLLECTIONS.COLLECTION.BUDGET.DELETE.COMPLETED]: (state, { payload: { budgetId } }: any): IBudgetState => {
            const newState = { ...state };
            delete newState[budgetId];
            return newState;
        },

        [COLLECTIONS.COLLECTION.BUDGET.CALCULATE.COMPLETED]: (
            state,
            { payload: { budgetId, currentQuantity, currentAmount } }: any
        ): IBudgetState => {
            const currentBudget = state[budgetId];

            return {
                ...state,
                [budgetId]: {
                    ...currentBudget,
                    currentQuantity,
                    currentAmount,
                },
            };
        },
    },
    initialState
);

interface IBudgetState {
    [budgetId: string]: IBudget;
}

interface IFetchCompletedAction {
    payload: { [budgets: string]: IBudget[] };
}

interface IBudget {
    id: string;
    name: string;
    amount: number;
    quantity: number;
    dimensions: { [key: string]: string[] };
    currentQuantity: number;
    currentAmount: number;
}
